import { CONFERENCE_PARTICIPANT_STATUS, ConferenceParticipantStatus } from "@regal-voice/shared-types";

export const TASK_STATUS_DISPLAY = {
    CONNECTING: "Connecting...",
    RINGING: "Ringing...",
    LIVE: "Live",
    ACTIVE: "Active",
    COMPLETED: "Completed",
    CANCELED: "Canceled",
    WRAP_UP: "Wrap Up",
};

export const DISCONNECTED_STATUSES: ConferenceParticipantStatus[] = [
    CONFERENCE_PARTICIPANT_STATUS.completed,
    CONFERENCE_PARTICIPANT_STATUS.noAnswer,
    CONFERENCE_PARTICIPANT_STATUS.failed,
    CONFERENCE_PARTICIPANT_STATUS.canceled,
    CONFERENCE_PARTICIPANT_STATUS.busy,
];
export const ALLOWED_STATUSES: ConferenceParticipantStatus[] = [
    CONFERENCE_PARTICIPANT_STATUS.initiated,
    CONFERENCE_PARTICIPANT_STATUS.inProgress,
    CONFERENCE_PARTICIPANT_STATUS.ringing,
];
